import styled from 'styled-components';
import { TagCloseButtonMixin } from '../../mixins/components/TagCloseButtonMixin';
export var StyledTagCloseButton = /*#__PURE__*/styled.button.withConfig({
  displayName: "StyledTagCloseButton",
  componentId: "c11n-8-107-0__sc-1lm2q1d-0"
})(["", ""], TagCloseButtonMixin);